/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ActionSource {
  STAFF = 'staff',
  CUSTOMER = 'customer',
  API = 'api',
}
